import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {NotificationService} from './notification.service';
import {Utilities} from '../../utils/utilities';
@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    private readonly statusCodeTitleMap: { [key: number]: string } = {
        400: 'error.badRequest',
        401: 'error.unauthorized',
        403: 'error.forbidden',
        404: 'error.notFound',
        405: 'error.methodNotAllowed',
        408: 'error.requestTimeOut',
        409: 'error.conflict',
        500: 'error.internalServerError',
        501: 'error.notImplemented',
        502: 'error.badGateway',
        503: 'error.serviceUnavailable',
        504: 'error.gatewayTimeout',
        505: 'error.httpVersionNotSupported',
        420: 'error.constraintViolation',
        440: 'error.fileError',
    };

    private readonly errorTypeMessageFunctions:{[key:string]:(err) =>string} ={
        ConstraintViolation: (err) =>{
            const violation = err.error.attribute.violations.split(':');
            return violation[1];
        }
    }
    private readonly isProduction: boolean;

    constructor(private notificationService: NotificationService) {
        this.isProduction = Utilities.isProduction();
    }

    handleError(err: any) {
        if (!this.isProduction) {
            console.log(err);
        }
        if (err.error.attribute) {
            this.handleOwnError(err);
        } else {
            this.handleDefaultError(err);
        }

    }

    private handleOwnError(err: any) {
        const title = this.statusCodeTitleMap[err.status];
        let message = err.error.attribute.message;
        if(Object.keys(this.errorTypeMessageFunctions).includes(err.error.type)){
            message = this.errorTypeMessageFunctions[err.error.type](err);
        }
        this.notificationService.showError(message,title);
        if (!this.isProduction && err.error.attribute.devMessage) {
            this.notificationService.showError('error.devMessage', err.error.attribute.devMessage);
        }
    }

    private handleDefaultError(err: HttpErrorResponse) {
        const title = this.statusCodeTitleMap[err.status];
        const message = err.error.path ? err.error.path : '';
        this.notificationService.showError(message,title);

    }


}
